<div class="package-card">
  <div class="package-main">
    <div class="package-info">
      <div class="bulto">
        <span class="label">{{ 'SHIPMENT.PACKAGE.PACKAGEKEY.CAPTION' | translate }}</span>
        <span class="value">{{ package.packageKey }}</span>
      </div>

      <div class="pedido">
        <span class="label">{{ 'SHIPMENT.PACKAGE.CUSTOMERREFERENCE.CAPTION' | translate }}</span>
        <span class="ref">{{ package.customerReference }}<shared-copyclipboard
            [value]="package.customerReference"></shared-copyclipboard></span>
      </div>

      <div class="descripcion">
        {{ package.shipmentDescription }}
      </div>

      <div class="chip">{{getResourcePalletCount()}} {{
        getResourcePalletType() | translate }}</div>
    </div>
  </div>
</div>